export default __webpack_public_path__ + "static/media/AWC.df09c660.jfif";